import * as angular from "angular";

interface SplitPascalCaseParams {
    ignoreDigits?: boolean;
}

export function splitPascalCase() {

    return (input: string, params?: SplitPascalCaseParams) => {

        if (params?.ignoreDigits) {
            return (!!input)
                ? input.replace(/([A-Z][a-z])/g, " $1").trim()
                : "";
        }

        return (!!input)
            ? input.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1").trim()
            : "";
    }
}
